import { render } from "./AddView.vue?vue&type=template&id=6840f397&scoped=true"
import script from "./AddView.vue?vue&type=script&lang=js"
export * from "./AddView.vue?vue&type=script&lang=js"

import "./AddView.vue?vue&type=style&index=0&id=6840f397&scoped=true&lang=css"

import exportComponent from "/Users/rose/src/golinks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6840f397"]])

export default __exports__